import React from 'react';
import type { StylesConfig, ThemeConfig } from 'react-select';
import Select from 'react-select';
import { DOC_TYPES } from '../../routes/Checkout/store/constants/tourists';
import type { DocType } from './types';

interface Props {
  /**
   * заменить string на DocType, когда попадет в прод
   * @see https://github.com/LevelTravel/leveltravel/blob/b11283d1a16356d4105ac1c5de7c59d0fa6285c2/client/lt-modules/src/routes/Package/containers/Tourists/types.ts#L11
   */
  onChange: (docType: string) => void;
  value?: string | null;
  color?: string;
  fontSize?: number;
  fontStyle?: string;
  fontWeight?: string | number;
  availableDocTypes: DocType[];
}

class DocumentType extends React.PureComponent<Props> {
  static startCase = (str) => str[0].toUpperCase() + str.substring(1);

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { value, onChange } = this.props;
    if (!value) {
      const defaultType = this.docTypes[0];
      if (defaultType?.id) onChange(defaultType.id);
    }
  }

  componentDidUpdate() {
    if (!this.selectedOption) {
      const [selected] = this.options;
      this.handleChange(selected);
    }
  }

  handleChange(event) {
    const { value } = event;
    const { onChange } = this.props;
    onChange(value);
  }

  get docTypes() {
    const { availableDocTypes } = this.props;
    return Object.keys(DOC_TYPES)
      .filter((type) => availableDocTypes?.includes(type as DocType))
      .map((type) => DOC_TYPES[type]);
  }

  get options() {
    return this.docTypes.map(({ id, name }) => ({
      value: id,
      label: DocumentType.startCase(name),
    }));
  }

  get selectedOption() {
    const { value } = this.props;
    return this.options.find((option) => option.value === value);
  }

  render() {
    const { options } = this;
    const { color, fontSize, fontStyle, fontWeight } = this.props;
    const styles: StylesConfig = {
      control: () => ({ display: 'flex' }),
      menu: (base) => ({
        ...base,
        width: 'auto',
        marginTop: 0,
        zIndex: 'calc(infinity)',
      }),
      option: (base) => ({ ...base, whiteSpace: 'nowrap' }),
      singleValue: (state) => ({
        cursor: state.isDisabled ? 'default' : 'pointer',
      }),
      valueContainer: () => ({
        display: 'flex',
        alignItems: 'center',
        color,
        fontSize,
        fontStyle,
        fontWeight,
      }),
      indicatorSeparator: () => ({ display: 'none' }),
      dropdownIndicator: (base, state) =>
        state.isDisabled
          ? { display: 'none' }
          : { ...base, padding: 0, paddingTop: '4px' },
    };
    const theme: ThemeConfig = (base) => ({
      ...base,
      borderRadius: 8,
      colors: {
        ...base.colors,
        primary: 'var(--secondary)',
        primary25: 'var(--lightorange)',
        primary50: 'var(--lightorange)',
        primary75: 'var(--lightorange)',
      },
    });
    return (
      <Select
        styles={styles}
        value={this.selectedOption}
        options={options}
        onChange={this.handleChange}
        isDisabled={options.length <= 1}
        isSearchable={false}
        theme={theme}
      />
    );
  }
}

export default DocumentType;
